export function fetchSchema ({ schemaUrl, extensionsBaseUrl }) {
  if (!schemaUrl) {
    return Promise.reject(
      new Error('No `schemaUrl` defined. Check the configuration.')
    )
  }
  return race([
    window
      .fetch(schemaUrl)
      .then(res => {
        if (!res.ok) {
          throw new Error('Failed to load the schema! ' + schemaUrl)
        }
        return res.json()
      })
      .then(schema => {
        const extensions =
          typeof schema.extensions === 'object' ? schema.extensions : {}

        Object.keys(extensions).forEach(extensionId => {
          const options = extensions[extensionId]
          const script = document.createElement('script')
          script.src = `${extensionsBaseUrl}/${extensionId}.js`
          Object.keys(options).forEach(key => {
            script.dataset[key] = options[key]
          })
          document.body.appendChild(script)
        })

        return schema
      }),
    timeout({ message: 'Error loading the schema!' })
  ])
}

export function fetchIntegration (integrationUrl) {
  if (!integrationUrl) {
    return Promise.reject(
      new Error('No `integrationUrl` defined. Check the configuration.')
    )
  }
  return race([
    new Promise(resolve => {
      function cb ({ currentTarget, type, origin, data: { injections } = {} }) {
        if (origin === window.location.origin && injections) {
          currentTarget.removeEventListener(type, cb)
          resolve()
        }
      }
      window.addEventListener('message', cb)

      const script = document.createElement('script')
      script.src = integrationUrl
      document.body.appendChild(script)
    }),
    timeout({ message: 'Error loading the integration!' })
  ])
}

export function timedSubmit ({ submitPromise, ...timeoutArgs }) {
  return race([submitPromise, timeout(timeoutArgs)])
}

function race (promises) {
  return new Promise((resolve, reject) => {
    promises.forEach(p => p.then(resolve, reject))
  })
}

function timeout ({ ms = 10000, message = 'Timed out!', ...errorProps } = {}) {
  return new Promise((_, reject) => {
    setTimeout(() => {
      const error = new Error(message)
      reject(Object.assign(error, errorProps))
    }, ms)
  })
}
